import React, { useState } from "react";
import { Button } from "@cofano/cck";
import DocumentDrawer from "components/documents/DocumentDrawer";
import { intl } from "LocaleWrapper";

export type DocumentButtonProps = {
	documentId: number
};

export const SdsDocumentButton = ({ documentId }: DocumentButtonProps) => {

	const [ documentDrawer, setDocumentDrawer ] = useState({ open: false });

	const showDocument = () => {
		setDocumentDrawer({ open: true });
	};

	return (
		<div>
			<Button
				onClick={() => showDocument()}
				variant={"text"}
				size="small"
			>
				{intl.formatMessage({ id: "SDS_DOCUMENT" })}
			</Button>

			<DocumentDrawer
				open={documentDrawer.open}
				onClose={() => setDocumentDrawer({ open: false })}
				previewUrl={`documents/preview/${documentId}`}
				url={`documents/download/${documentId}`}
			/>
		</div>
	);
};
